/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-15 10:41:04
 */

import { Component } from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import { VideoDOI } from "./api/videoApi";
import VideoService from "./service/videoService";

@Component({ name: 'video' })
export default class Video extends BasicSearchPage<VideoService, VideoDOI.RowDataI, VideoDOI.QueryRowDataParamsI> {

   @override
   renderHead(h) {
      return <div></div>
   }

   @override
   loadService() {
      this.service = new VideoService(this)
   }
}